// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getwishListLoadingTime } from "@synd/XDL/Utilities";

export const DispatchSetListLoadingAction: any = (props: any) => {
    const { isLoading, wishList } = props.parameter;
    props.dispatch({
        type: "xCommon/update",
        data: {
            key: "listsLoading",
            value: { isLoading, seconds: wishList ? getwishListLoadingTime(props.wishList) : 0 },
        },
    });
};

export const chain = [DispatchSetListLoadingAction];

const setListLoadingAction = createHandlerChainRunner(chain, "setListLoadingAction");
export default setListLoadingAction;
